import { updatePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const borderColors = {
  focusBorderColor: 'var(--p-primary)',
  hoverBorderColor: 'var(--p-primary)',
}

const Verona = updatePreset(Aura, {
  components: {
    dialog: {
      root: {
        borderRadius: '0px',
      },
    },
    button: {
      root: {
        primary: {
          activeBorderColor: 'var(--p-primary)!important',
          activeBackground: 'var(--p-primary)',
        },
      },
    },
    checkbox: {
      root: {
        checkedHoverBorderColor: 'transparent',
        checkedDisabledBorderColor: 'transparent',
      },
    },
    textarea: {
      root: borderColors,
    },
    select: {
      root: borderColors,
    },
    inputtext: {
      root: borderColors,
    },
    tabs: {
      activeBar: {
        background: 'var(--p-primary)',
      },
    },
    floatlabel: {
      root: {
        focusColor: 'var(--p-primary)',
        activeColor: '#1e1e1e',
      },
    },
  },
  semantic: {
    primary: {
      50: 'var(--p-surface-50)',
      100: 'var(--p-surface-100)',
      200: 'var(--p-surface-200)',
      300: 'var(--p-surface-300)',
      400: 'var(--p-surface-400)',
      500: 'var(--p-surface-500)',
      600: 'var(--p-surface-600)',
      700: 'var(--p-surface-700)',
      800: 'var(--p-surface-800)',
      900: 'var(--p-surface-900)',
      950: 'var(--p-surface-950)',
    },
    colorScheme: {
      light: {
        primary: {
          color: 'var(--primary-color)',
          inverseColor: 'var(--p-primary-contrast-color)',

          hoverColor: 'var(--p-primary-hover-color)',
          activeColor: 'var(--p-primary-active-color)',
        },
        highlight: {
          background: 'var(--p-highlight-background)',
          focusBackground: 'var(--p-highlight-focus-background)',
          color: 'var(--p-highlight-color)',
          focusColor: 'var(--p-highlight-focus-color)',
        },
      },
      dark: {
        primary: {
          color: 'var(--primary-color)',
          inverseColor: 'var(--p-primary-contrast-color)',
          hoverColor: 'var(--p-primary-hover-color)',
          activeColor: 'var(--p-primary-active-color)',
        },
        highlight: {
          background: 'var(--p-highlight-background)',
          focusBackground: 'var(--p-highlight-focus-background)',
          color: 'rgba(255, 255, 255, 0.87)',
          focusColor: 'rgba(255, 255, 255, 0.87)',
        },
      },
    },
  },
})

export default {
  preset: Verona,
  options: {
    darkModeSelector: false,
    cssLayer: {
      name: 'primevue',
      order:
        'tailwind-base, base, typo, fonts, layout, animation, responsive, project,  primevue, tailwind-utilities',
    },
  },
}
